import Vue from 'vue';
import Vuetify from 'vuetify/lib';

const vuetifyOpts = {
    rtl: false,
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#004996',
                accent: '#DBD8D6',
                secondary: '#00B4E3',
                success: '#4CAF67',
                info: '#DBD8D6',
                warning: '#FF5B32',
                error: '#F43414'
            }
        }
    }
};


export default new Vuetify(vuetifyOpts);

Vue.use(Vuetify);